import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { setSupportedAttachmentFormats } from 'utils/attachmentFormatUtil';

/**
 * Loads the attachment formats allowed on a drag-and-drop note and mirrors them into the module
 * cache the yup schema reads, so the dialog and the save validation always use the same list.
 */
export const useGetSupportedAttachmentFormats = () => {
  const query = useQuery<string[], AxiosError>({
    queryKey: ['supportedAttachmentFormats'],
    queryFn: () => contactNoteDialogService.getSupportedAttachmentFormats(),
    staleTime: Number.POSITIVE_INFINITY,
  });

  useEffect(() => {
    if (query.data) {
      setSupportedAttachmentFormats(query.data);
    }
  }, [query.data]);

  return query;
};

export default useGetSupportedAttachmentFormats;
